import { render } from "./PackageGolfAvailability.vue?vue&type=template&id=9b84e78e&scoped=true"
import script from "./PackageGolfAvailability.vue?vue&type=script&lang=js"
export * from "./PackageGolfAvailability.vue?vue&type=script&lang=js"

import "./PackageGolfAvailability.vue?vue&type=style&index=0&id=9b84e78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b84e78e"]])

export default __exports__